var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.635,
    height: 17.806,
    viewBox: "0 0 16.635 17.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-attachment-7009311",
    transform: "translate(284.979 -272.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50136",
    "data-name": "Path 50136",
    d: "M9.622,20.287a2.067,2.067,0,0,1,.038-2.881l6.754-6.754a3.51,3.51,0,0,1,4.964,0l0,0a3.511,3.511,0,0,1,0,4.964l-2.269,2.27a.62.62,0,1,1-.877-.877l2.27-2.269a2.271,2.271,0,0,0,0-3.211l0,0a2.271,2.271,0,0,0-3.211,0l-6.753,6.754a.815.815,0,0,0-.24.582.823.823,0,0,0,.238.581l0,0a.826.826,0,0,0,1.165,0l6.109-6.109a.62.62,0,0,1,.877.877l-6.109,6.109a2.065,2.065,0,0,1-2.919,0l0,0-.038-.038Zm-1.9,1.977,0,0a4.956,4.956,0,0,1,0-7.009l8.611-8.611a.62.62,0,0,1,.877.877L8.6,16.131a3.716,3.716,0,0,0,0,5.255l0,0a3.718,3.718,0,0,0,5.252,0L15.6,19.643a.62.62,0,0,1,.877.877l-1.743,1.743a4.957,4.957,0,0,1-7.009,0,.621.621,0,0,0,.438.181l0,0a.618.618,0,0,1-.434-.18Z",
    transform: "translate(-291 266)",
    fill: "#4a4a4a",
    stroke: "#4a4a4a",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.71a4a5acc584775ed2ec875a14eca0ed.svg";
export { ForwardRef as ReactComponent };